

  // const image_api = 'https://veezzo-s3-bucket.s3.ap-south-1.amazonaws.com/test/';
  //  const var_api = 'https://test-api.veezzo.in/';
// //  const var_api = 'http://3.111.39.74:5000/';


// //   const image_api = 'https://veezzo-s3-bucket.s3.ap-south-1.amazonaws.com/';
// //     const var_api = 'https://live-api.veezzo.in/';

//  const image_api = 'http://localhost:5000/';

// export { var_api, image_api }




 // TEST SERVER 
//  const image_api = 'https://veezzo-s3-bucket.s3.ap-south-1.amazonaws.com/test/';
  // const var_api = 'https://test-api-rfpos.digihopetechnologies.com/';
    const var_api = 'https://api-rfpos.digihopetechnologies.com/'; //live
//  const var_api = 'https://test-api.veezzo.in/';
//  const var_api = 'http://localhost:3500/';



// PRODUCTION SERVER

   const image_api = 'https://veezzo-s3-bucket.s3.ap-south-1.amazonaws.com/'; //live
  //   const var_api = 'https://live-api.veezzo.in/';


export { var_api, image_api }